import React from "react";
import {
  compose,
  withHandlers,
  defaultProps,
  withStateHandlers,
} from "recompose";
import { ApiClient } from "services";
import { noop } from "lodash";
import PendingButton from "components/common/PendingButton";
import { Trans } from "react-i18next";

const Aux = (props) => props.children;

const DisconnectButton = ({ ...props }) => (
  <PendingButton className="px-1 py-0 ml-1 btn-danger" size="sm" {...props}>
    Disconnect
  </PendingButton>
);
export const ConnectionStatus = ({
  item,
  showDisconnect = false,
  disconnect,
  pending,
  ...props
}) => (
  <Aux {...props}>
    {!item.status ||
      (item.status === "NOT_CONNECTED" && (
        <div className="my-2">
        <span className="text-danger">
          <Trans>Not connected to Xero</Trans>
        </span>
        </div>
      ))}
    {item.status === "LIVE" && (
      // <div className="d-flex align-items-center">
      <div className="align-items-center">
      
        <span className="text-success">
          <Trans>
            Connected to{" "}
            {{ organisation: item.xero_organisation_name || "Xero" }}{" "}
          </Trans>
        </span>
        {showDisconnect && (
          <DisconnectButton onClick={disconnect} pending={pending} />
        )}
      </div>
    )}
    {item.status === "TOKEN_EXPIRED" && (
      // <div className="d-flex align-items-center">
      <div className="align-items-center">
  
        <span className="text-danger align-items-center">
          <Trans>
            Connection to{" "}
            {{ organisation: item.xero_organisation_name || "Xero" }} invalid
          </Trans>
        </span>
        {showDisconnect && (
          <DisconnectButton onClick={disconnect} pending={pending} />
        )}
      </div>
    )}
  </Aux>
);

export const enhance = compose(
  defaultProps({
    onDisconnected: noop,
  }),
  withStateHandlers(
    {},
    {
      setPending: () => (pending) => ({ pending }),
    }
  ),
  withHandlers({
    disconnect:
      ({ item, setPending, onDisconnected }) =>
      () => {
        setPending(true);
        const client = ApiClient();
        client
          .post(`connected_organisations/${item.id}/disconnect`)
          .then((resp) => onDisconnected(resp.data))
          .finally(() => setPending(false));
      },
  })
);
export default enhance(ConnectionStatus);
